import type { ReactNode } from 'react';
import { initials } from '../../lib/format';
import './record-header.css';
/**
 * One record header for every vertical. Identity details and permitted actions
 * come from the caller. The monogram is centered on the name and its key-facts
 * line (`facts`) together; whatever else the caller passes (`children`: the
 * identity line, links, dates) sits under them in the name's column.
 */
export function RecordHeader({
  name,
  facts,
  children,
  actions,
}: {
  name: string;
  facts?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="record-head">
      <div className="monogram">{initials(name)}</div>
      <div className="identity">
        <div className="name">{name}</div>
        {facts}
      </div>
      {children ? <div className="identity-more">{children}</div> : null}
      {actions}
    </div>
  );
}
